import { ServiceException } from './service-exception';

export class FareCalculationNotFoundException extends ServiceException { }
